import List from 'frontend/components/program-year/list';
<template><List @canCreate={{@controller.canCreate}} @program={{@model}} /></template>
